import React, { useState } from 'react';
import { Responsive } from '@/ui';
import { ISiteSectionEntry } from '@move-frontend/contentful';
import DesktopNavigation from './desktop/DesktopNavigation';
import { useCommonData } from '../../../common-data/useCommonData';
import { getOrderedSiteSections } from '../../../navigation/getOrderedSiteSections';
import MobileNavigation from './mobile/MobileNavigation';

interface IProps {
	type?: 'primary' | 'secondary';
	isSticky: boolean;
	siteSection?: ISiteSectionEntry;
}

export default function Navigation({
	type = 'primary',
	isSticky,
	siteSection,
}: IProps) {
	const { siteSections } = useCommonData();
	const isMobile = !!Responsive.useMatchesBreakpoint('mobileXL');
	const orderedSiteSections = getOrderedSiteSections(siteSections);

	const [siteSectionId, setSiteSectionId] = useState(siteSection?.fields.id);

	if (isMobile) {
		return (
			<MobileNavigation
				siteSections={orderedSiteSections}
				onSiteSectionIdChange={setSiteSectionId}
				siteSectionId={siteSectionId}
				items={siteSection?.fields.menuItems}
				isSticky={isSticky}
			/>
		);
	}

	return (
		<DesktopNavigation
			siteSections={orderedSiteSections}
			onSiteSectionIdChange={setSiteSectionId}
			siteSectionId={siteSectionId}
			siteSection={siteSection}
			type={type}
			isSticky={isSticky}
		/>
	);
}
